/**
 * FNV-1a, 32 bit, over the text's UTF-16 code units: a fast, stable hash for picking a
 * look from a name or an ID. Not for security.
 */
export function fnv1a32(text: string): number {
  let hash = 0x811c9dc5;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}
